import { HiShieldCheck } from "react-icons/hi";
import { MdCancel, MdAnalytics } from "react-icons/md";
const wingdata = [
  {
    icon: <MdCancel />,
    heading: "Prevent carbon-footprint ",
    detail:
      "We planned to create an elctric car from scratch that opparates with elctricity to be an alternative for fossile liquids and so that we can reduce carbon foot prints released by them and support electric vehicles",
  },
  {
    icon: <MdAnalytics />,
    heading: "Automobile Workshops",
    detail:
      " we are committed to fostering a culture of continuous learning and growth. Through engaging workshops, technical sessions, and industry collaborations, we provide our members with the opportunity to enhance their skillsets and broaden their horizons. We believe in the power of collaboration and encourage our members to contribute their ideas, passion, and expertise towards making our club a center of excellence in automobile engineering .",
  },
  {
    icon: <HiShieldCheck/>,
    heading: "To create a F1 car",
    detail:
      " Our ambition is to create a legacy of excellence in automobile engineering. With a strong emphasis on teamwork, dedication, and innovation, we strive to push the boundaries of what is possible. Together, we will work towards constructing a Formula Student Car that represents the culmination of our collective efforts and expertise. By participating in prestigious events and competitions, we aim to showcase our technical prowess and bring recognition to our institute.",
  },
];
export default wingdata;
